// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2wVSn","messages":"Chat_messages__2JxJv","dateDivider":"Chat_dateDivider__3lVI9"};